export default __webpack_public_path__ + "static/media/smit.fafe6ee5.jpeg";